import React from "react";
import { Link } from "react-router-dom";

const LOGO = "https://static.prod-images.emergentagent.com/jobs/8962d87f-5340-48e7-814b-3b48c07b8527/images/33fa04d940b63e5bb86ca356d2da2b912f6196a5aa3a47cb300b50b4210b14aa.png";

export default function Header({ variant = "default" }) {
  const isGlass = variant === "glass";
  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 ${
        isGlass
          ? "bg-white/70 backdrop-blur-xl border-b border-white/40"
          : "bg-white border-b border-slate-200"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-16 flex items-center justify-between">
        <Link to="/" data-testid="header-logo-link" className="flex items-center gap-3">
          <img src={LOGO} alt="Maui Starpower" className="h-9 w-9 rounded-lg" />
          <div className="flex flex-col leading-tight">
            <span className="font-display font-bold text-[15px] tracking-tight text-slate-900">
              HI Power Savings AI
            </span>
            <span className="text-[10px] uppercase tracking-[0.18em] text-sky-600 font-semibold">
              by Maui Starpower
            </span>
          </div>
        </Link>
        <nav className="flex items-center gap-2 sm:gap-4">
          <Link
            to="/analyze"
            data-testid="header-analyze-link"
            className="hidden sm:inline-flex items-center text-sm font-semibold text-slate-700 hover:text-slate-900 px-4 py-2 rounded-full hover:bg-slate-50 transition-colors"
          >
            Analyze My Bill
          </Link>
          <Link
            to="/admin/login"
            data-testid="header-admin-link"
            className="text-sm font-semibold text-slate-500 hover:text-slate-900 px-3 py-2 rounded-full transition-colors"
          >
            Admin
          </Link>
        </nav>
      </div>
    </header>
  );
}
